import { render, staticRenderFns } from "./WarehouseViewSalesPricing.vue?vue&type=template&id=476bbb61"
import script from "./WarehouseViewSalesPricing.vue?vue&type=script&lang=js"
export * from "./WarehouseViewSalesPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports